import React, { Component } from 'react';
import { SKUS } from '../constants';

class SkuSelect extends Component {
  constructor(props) {
    super(props);

    this.state = { selectedSkus: this.props.defaultSelection };

    this.handleSelectionChange = this.handleSelectionChange.bind(this);
    this.handleCostChange = this.handleCostChange.bind(this);
  }

  handleSelectionChange({target: { value, checked }}) {
    let newSkus;
    if (checked) {
      newSkus = [...this.state.selectedSkus, value]
    } else {
      newSkus = this.state.selectedSkus.filter(sku => sku !== value);
    }
    this.setState({ selectedSkus: newSkus });
    this.props.onSelectionChange('skuCodes', newSkus);
  }

  handleCostChange(skuCode, cost) {
    this.props.onCostChange(skuCode, cost);
  }

  renderCheckboxes(defaultSelection) {
    return SKUS.map(sku => (
      <div key={sku.skuCode} className="sku-option">
        <input
          type="text"
          defaultValue={sku.defaultCost}
          disabled={!this.state.selectedSkus.includes(sku.skuCode)}
          onChange={e => this.handleCostChange(sku.skuCode, e.target.value)}
          className="digits_4"
          style={{ marginRight: '8px' }}
        />
        <input
          type="checkbox"
          name="sku_cd"
          value={sku.skuCode}
          checked={this.state.selectedSkus.includes(sku.skuCode)}
          onChange={this.handleSelectionChange} />
        &nbsp; {sku.sku_name}
      </div>
    ));
  }

  render() {
    const { defaultSelection } = this.props;

    return (
      <tr>
        <th><label htmlFor="skuCode">Product(s)</label></th>
        <td>
          {this.renderCheckboxes(defaultSelection)}
        </td>
      </tr>
    );
  }
}

export default SkuSelect;
